export default "__VITE_ASSET__Bm$Xw7YR__"